import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { fieldBoxSlot } from './slot.vanilla.mjs';

const FieldBoxSlot = forwardRef(
  ({ className: classNameFromProps, ...props }, forwardedRef) => {
    const className = classNames(fieldBoxSlot, classNameFromProps);
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        "data-scope": "field-box",
        "data-part": "slot",
        className,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
FieldBoxSlot.displayName = "FieldBox.Slot";

export { FieldBoxSlot };
//# sourceMappingURL=Slot.mjs.map
